// register component(s) with react habitat
import LazyComponent from './index'

export default {
  ConfigPlus: LazyComponent,
}
